//const server_url = "http://localhost:3000/getInfo"

//const server_url = "https://pageturnerserver.onrender.com/getInfo"
const server_url = "https://page-turner-server.vercel.app/getInfo";

export default server_url;